import { useIntl } from 'react-intl';

import { Col } from '@/components/Col';
import { Flex } from '@/components/Flex';
import type { InputErrorMessageProps } from '@/components/InputErrorMessage';
import { InputErrorMessage } from '@/components/InputErrorMessage';
import { InputField } from '@/components/InputField';
import { SelectField } from '@/components/SelectField';
import { Typography } from '@/components/Typography';
import { usePhoneInput } from '@/hooks/usePhoneInput';
import { CONTENTSQUARE_MASKED } from '@/lib/forms/const';
import { getPhonePrefixSelectOpts } from '@/lib/phonePrefixes/helpers';
import { formMessages } from '@/messages/forms';

import * as S from './CatalogDownloadForm.styles';

export interface PhoneInputProps {
  error?: InputErrorMessageProps['error'];
}

export const PhoneInput = ({ error }: PhoneInputProps) => {
  const { formatMessage } = useIntl();
  const { examplePhone } = usePhoneInput();

  return (
    <S.PhoneRow gapDensity='none'>
      <Col xs={6}>
        <SelectField
          colorVariant='grey'
          isDisabled={false}
          name='phonePrefix'
          options={getPhonePrefixSelectOpts()}
          variant='default'
        />
      </Col>
      <Col xs={6}>
        <Flex flexDirection='column'>
          <InputField
            autoComplete='phone'
            className={CONTENTSQUARE_MASKED}
            colorVariant='grey'
            disabled={false}
            name='phone'
            pattern='[0-9]+'
            placeholder={formatMessage(formMessages.telephoneNumber)}
            required
            type='text'
          />
          <InputErrorMessage error={error} />
          <Typography color='secondaryGrey' scale='p3' textAlign='right'>
            {examplePhone}
          </Typography>
        </Flex>
      </Col>
    </S.PhoneRow>
  );
};
